import { render } from "./YouthProtectionPage.vue?vue&type=template&id=6b15e73c&scoped=true"
import script from "./YouthProtectionPage.vue?vue&type=script&lang=js"
export * from "./YouthProtectionPage.vue?vue&type=script&lang=js"

import "./YouthProtectionPage.vue?vue&type=style&index=0&id=6b15e73c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b15e73c"]])

export default __exports__